import React, { Component } from 'react';
import ActionButton from 'jbc-front/components/ActionButton';

import {
  CLIENT_EMPLOYMENT_TYPES_URL,
  CLIENT_GROUPS_URL,
  CLIENT_POSITIONS_URL,
  CLIENT_OCCUPATIONS_URL,
  CLIENT_PAYROLL_RULES_GROUP_LIST,
  LIST_CLIENTS_URL
} from 'src/constants/EndpointUrls';
import styles from '../styles/FileImport.scss';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import i18next from 'i18next';

class ShowMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMoreOpen: false
    };
  }

  handleClickOpen = () => {
    this.setState({
      isMoreOpen: true
    });
  };

  handleClickClose = () => {
    this.setState({
      isMoreOpen: false
    });
  };

  render() {
    const { children } = this.props;

    return (
      <React.Fragment>
        {this.state.isMoreOpen ? (
          <React.Fragment>
            {children}
            <div className={styles.more} onClick={this.handleClickClose} role="presentation">
              {i18next.t('features.Employees.components.FileImportDescription.hide')}
            </div>
          </React.Fragment>
        ) : (
          <div className={styles.more} onClick={this.handleClickOpen} role="presentation">
            {i18next.t('features.Employees.components.FileImportDescription.show_list')}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const FileImportDescription = props => {
  const { t } = useTranslation();
  const { titles } = props;

  return (
    <div className="l-wrap-xl">
      <div className="l-overflow-scroll">
        <table className="m-table-description">
          <thead>
            <tr>
              <th className="m-table-description-item-name">{t('features.Employees.components.FileImportDescription.data_item_name')}</th>
              <th>{t('features.Employees.components.FileImportDescription.description')}</th>
              <th className="m-table-description-example">{t('features.Employees.components.FileImportDescription.example')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.staff_code')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_10_digits')}</td>
              <td>111</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.last_name')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.yamada')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.first_name')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.taro')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.personal_id')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_with_9_to_13_digits')}</td>
              <td>XXXXXXXXXXXXX</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.nationality')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_nationality')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.birthday')}</th>
              <td>-</td>
              <td>01/01/1980</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.email')}</th>
              <td>
                {t(
                  'features.Employees.components.FileImportDescription.Please_note_that_if_you_change_your_email_address_your_account_for_MyPage_login_will_also_be_changed'
                )}
              </td>
              <td>yamada@jobcan.ne.jp</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.phone_number')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_with_10_digits')}</td>
              <td>0912345678</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.address_province')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_province')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.address_subdistrict')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_subdistrict')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.address')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_address')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.postal_code')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_with_5_digits')}</td>
              <td>10310</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.office')}</th>
              <td>
                <ActionButton as="a" href={LIST_CLIENTS_URL}>
                  {t('features.Employees.components.FileImportDescription.confirm_office')}
                </ActionButton>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_office')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.employment_type')}</th>
              <td>
                <ActionButton as="a" href={CLIENT_EMPLOYMENT_TYPES_URL}>
                  {t('features.Employees.components.FileImportDescription.confirm_employment_type')}
                </ActionButton>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.full_time_employee')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.position')}</th>
              <td>
                <ActionButton as="a" href={CLIENT_POSITIONS_URL}>
                  {t('features.Employees.components.FileImportDescription.confirm_position')}
                </ActionButton>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_position')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.occupation')}</th>
              <td>
                <ActionButton as="a" href={CLIENT_OCCUPATIONS_URL}>
                  {t('features.Employees.components.FileImportDescription.confirm_occupation')}
                </ActionButton>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.example_occupation')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.group')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Groups_can_be_set_up_to_five_levels')}
                <ActionButton as="a" href={CLIENT_GROUPS_URL} className="u-mt10">
                  {t('features.Employees.components.FileImportDescription.confirm_group')}
                </ActionButton>
              </td>
              <td>
                {t('features.Employees.components.FileImportDescription.example_values.sales_department')}-{'>'}
                {t('features.Employees.components.FileImportDescription.example_values.first_group')}-{'>'}
                {t('features.Employees.components.FileImportDescription.example_values.first_team')}
              </td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.first_day_at_work')}</th>
              <td>{t('features.Employees.components.FileImportDescription.date')} (dd/mm/yyyy)</td>
              <td>01/04/2010</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.retirement_date')}</th>
              <td>{t('features.Employees.components.FileImportDescription.date')} (dd/mm/yyyy)</td>
              <td>31/03/2018</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.retirement_division')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.general')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.handicap')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.death')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.general')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.starting_date_of_career_break')}</th>
              <td>{t('features.Employees.components.FileImportDescription.date')} (dd/mm/yyyy)</td>
              <td>01/12/2015</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.end_date_of_career_break')}</th>
              <td>{t('features.Employees.components.FileImportDescription.date')} (dd/mm/yyyy)</td>
              <td>31/03/2016</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.reason_for_career_break')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.personal_accident_and_sickness_leave')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.leave_before_and_after_childbirth')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.childcare_leave')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.nursing_care_leave')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.other')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.nursing_care_leave')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.salary_rule_group')}</th>
              <td>
                <ActionButton as="a" href={CLIENT_PAYROLL_RULES_GROUP_LIST}>
                  {t('features.Employees.components.FileImportDescription.confirm_salary_rule_group')}
                </ActionButton>
                <p className="u-mt10">
                  {t(
                    'features.Employees.components.FileImportDescription.The_following_information_in_the_Salary_Rules_group_cannot_be_imported_from_Employee_Information'
                  )}
                </p>
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.form_of_salary')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.designated_working_hours_in_one_day')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.average_designated_working_days_in_one_month')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.cutoff_date')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.payment_date')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.for_full_time_employee')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.basic_salary')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_13_digits')}</td>
              <td>30000000</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.Provision_and_deduction_items_set_in_the_Salary_Rules_group')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.must_be_within_9_digits')}
                <br />
                {t(
                  'features.Employees.components.FileImportDescription.You_can_register_values_for_provision_and_deduction_items_that_are_set_to_Set_Amount_in_Employee_List_in_Provision_and_Deduction_Item_Settings_Set_Amount_in_Salary_Rules'
                )}
              </td>
              <td>20000</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.Unit_price_set_in_the_Salary_Rules_group')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.must_be_within_9_digits')}
                <br />
                {t(
                  'features.Employees.components.FileImportDescription.Unit_prices_such_as_basic_unit_price_for_extra_wage_and_unit_price_for_absence_deductions_are_usually_calculated_based_on_the_salary_rules'
                )}
                <br />
                {t(
                  'features.Employees.components.FileImportDescription.For_employees_who_have_unit_price_registered_automatic_calculation_by_payroll_rules_will_be_disabled'
                )}
              </td>
              <td>1500</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.probation_setting_end_date')}</th>
              <td>{t('features.Employees.components.FileImportDescription.date')} (dd/mm/yyyy)</td>
              <td>31/12/2024</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.probation_setting_tax_setting')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.no_tax')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.ten_percent_tax')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.progressive_tax')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.progressive_tax')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.probation_setting_salary_type')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.columns.basic_salary')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.percentage_on_basic_salary')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.columns.basic_salary')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.probation_setting_salary_rate')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_3_digits')}</td>
              <td>100</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.probation_setting_basic_salary')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_13_digits')}</td>
              <td>30000000</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_bank_name')}</th>
              <td>
                ※{t(
                  'features.Employees.components.FileImportDescription.If_you_want_to_register_Account_Information_4_or_later_please_add_a_column_The_same_applies_to_the_following_items'
                )}
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.jobcan_bank')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_bank_short_name')}</th>
              <td>-</td>
              <td>JCB</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_bank_code')}</th>
              <td>{t('features.Employees.components.FileImportDescription.number')}</td>
              <td>01234567</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_branch_name')}</th>
              <td>-</td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.jobcan_branch')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_branch_code')}</th>
              <td>{t('features.Employees.components.FileImportDescription.number')}</td>
              <td>01234567</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_account_information_1_account_type')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.normal')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.current')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.normal')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.bank_information_1_account_number')}</th>
              <td>-</td>
              <td>1111111</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.payment_setting_salary_bank_transfer_1_to_3_amount_of_money')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <br />
                ・{t('features.Employees.components.FileImportDescription.total_amount')}
                <br />
              </td>
              <td>{t('features.Employees.components.FileImportDescription.total_amount')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.payment_setting_salary_bank_transfer_1_to_3_payee')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_from_registered_accounts')}
                <br />
                ・{t('features.Employees.components.FileImportDescription.bank_account_1')}
              </td>
              <td>{t('features.Employees.components.FileImportDescription.bank_account_1')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.payment_setting_salary_bank_transfer_1_to_3_transfer_source')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_from_registered_accounts')}
                <br />
                ・{t('features.Employees.components.FileImportDescription.bank_account_1')}
              </td>
              <td>{t('features.Employees.components.FileImportDescription.bank_account_1')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.payment_setting_salary_amount_paid_in_cash')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <br />
                ・{t('features.Employees.components.FileImportDescription.total_amount')}
                <br />
              </td>
              <td />
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.social_insurance_enrollment_status')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.registered')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.not_registered')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.registered')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.sso_calculated_amount')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.follow_salary_rules')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.amount')}</li>
                </ul>
              </td>
              <td>100000</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.social_insurance_number')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_10_digits')}</td>
              <td>XXXXXXXXXX</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.union_dues_contribution_status')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.registered')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.not_registered')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.registered')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.union_dues_type')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.rate')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.amount')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.rate')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.union_dues_amount')}</th>
              <td>{t('features.Employees.components.FileImportDescription.number')}</td>
              <td>100000</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_year')}</th>
              <td>{t('features.Employees.components.FileImportDescription.number')} (yyyy)</td>
              <td>2025</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_calculation_setting')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.tax_true')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.tax_false')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.tax_true')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_calculation_method')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.gross')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.net')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.gross')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_resident_classification')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.resident')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.non_resident')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.resident')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_non_resident_tax_setting')}</th>
              <td>
                {t('features.Employees.components.FileImportDescription.Please_select_one_of_the_following')}
                <ul>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.no_tax')}</li>
                  <li>・{t('features.Employees.components.FileImportDescription.example_values.calculate_at_20_percent')}</li>
                </ul>
              </td>
              <td>{t('features.Employees.components.FileImportDescription.example_values.calculate_at_20_percent')}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_dependants_number')}</th>
              <td>{t('features.Employees.components.FileImportDescription.number')}</td>
              <td>0</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_other_deductions_amount')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_13_digits')}</td>
              <td>0</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_charity_amount')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_13_digits')}</td>
              <td>0</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FileImportDescription.columns.tax_setting_abroad_income_tax_amount')}</th>
              <td>{t('features.Employees.components.FileImportDescription.must_be_within_13_digits')}</td>
              <td>0</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default connect(state => ({
  titles: getSelectOptions(state, 'titles')
}))(FileImportDescription);
